import Bar from './index.vue'
const codes = ['zzt']

export function installBar() {
  return codes.map(code => {
    const nameCode = code[0].toUpperCase() + code.substring(1)
    const name = `KyeReport${nameCode}`
    return {
      name,
      extends: Bar,
      data() {
        return {
          code,
        }
      },
    }
  })
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/bar/install.js